<template>
  <div :class="isPC ? 'show-content-area' : 'm-show-content-area'">

    <div v-show="showVideo">
      <div class="page-title">{{productInfo ? productInfo.worksName : ''}}</div>
      <p>主创者姓名：{{productInfo ? productInfo.creatorName : ''}}</p>
      <video class="video-js vjs-big-play-centered" id="video_show" controls preload="auto" poster="" data-setup='{}'></video>
      <div class="button-wrapper"><span @click="goBackToList()">{{currentLang === 'en' ? 'Back to list' : '返回列表'}}</span></div>
    </div>

    <div v-show="isShow">
      <!-- slide part -->
      <div class="carousel-wrapper">
        <SlideKr :picts="dataList" />
      </div>
      <!-- content part -->
    </div>

  </div>
</template>

<script>
import SlideKr from '@/common/SlideKr'
export default {
  name: 'ShowDetail',
  components: { SlideKr },
  props: ['productInfo', 'popInKr'],
  data () {
    return {
      player: null,
      dataList: [],
      showVideo: '',
      isShow: false,
    }
  },
  mounted () {
    if (this.productInfo) {
      this.isShow = false
      let videoInfos = this.productInfo.videoInfos || []
      for (let item of videoInfos) {
        if (item.useFor === 'show_video') {
          this.showVideo = item.filePath
          break
        }
      }
      if (this.showVideo) {
        /* eslint-disable */
        this.player = videojs(document.getElementById('video_show'))
        let media_type = ''
        if (this.showVideo.indexOf('.m3u8') !== -1) {
          media_type = 'application/x-mpegURL'
        } else if (this.showVideo.indexOf('.mp4') !== -1) {
          media_type = 'video/mp4'
        }
        this.player.src({
          src: this.showVideo,
          type: media_type
        })
      }
    } else {
      this.isShow = true
      this.getDataList()
    }
  },
  methods: {
    getDataList () {
      let data = this.$allData[this.currentLang] || []
      this.dataList = data.filter((i) => {
        return i.showType === 'person' && i.showVideoName
      }).map((i) => {
        let url  = ''
        for (let j of i.videoInfos) {
          if (j.useFor === 'show_video') {
            url = j.filePath
            break
          }
        }
        let item = {
          url: url,
          type: 'video'
        }
        return item
      })
    },
    goBackToList () {
      this.$router.push({name: 'youth_science', params: {subpath: 'show'}})
    }
  }
}
</script>

<style scoped>
  .show-content-area {
    width:120rem;
    margin: 5rem auto;
    text-align: center;
  }
  .m-show-content-area {
    width:100%;
    margin: 10px 0;
    text-align: center;
  }
  .page-title {
    text-align: center;
    color: #343434;
    padding-top: 1rem;
    padding-bottom: 2rem;
    font-size: 2.5rem;
  }
  .video-js {
    width: 100%;
    height: 600px;
  }
  .m-show-content-area .video-js {
    height: 400px;
  }
  .button-wrapper {
    width:100%;
    margin-top: 3rem;
    margin-bottom: 3rem;
    text-align: center;
  }
  .button-wrapper span {
    cursor: pointer;
    padding:  1rem 4rem;
    color: #ec6000;
    border-radius: 2rem;
    font-size: 1.8rem;
    border: 1px solid #ec6000;
  }
  .button-wrapper span:hover {
    background-color: #ec6000;
    color: #ffffff;
  }
</style>